import Vue from 'vue';
import $ from 'jquery';

const loading = new Vue({
  data: {
    isShow: false,
    isWhite: false
  },
  methods: {
    show (white) {
      this.isShow = true
      if (white) {
        this.isWhite = true
      }
      $('body').addClass('preloader-on')
    },
    hide () {
      this.isShow = false
      this.isWhite = false
      $('body').removeClass('preloader-on')
    }
  }
})

export default {
  install (Vue) {
    Vue.prototype.$loading = loading
  }
}
